import React from 'react';
import { reduxForm, change } from 'redux-form';
import { useSelector } from 'react-redux';
import { compose, withProps } from 'recompose';
import { onEnter } from 'spark-util/keyboardEvents';
import { useGridContext } from './gridContext';
import { filterHomePageGrid } from '../state/gridActions';
import { refreshManagement, refreshSort } from 'spark-grid';
import { getFilter } from '../state/gridSelectors';
import debounce from 'lodash/debounce';

const stopEnterEvent = onEnter((event) => {
	event.preventDefault();
	event.stopPropagation();
});

const FilterBuilderForm = ({ children }) => {
	return <div onKeyPress={stopEnterEvent}>{children}</div>;
};

const onSubmit = async (values, dispatch, {gridName}) => {
	 dispatch(filterHomePageGrid(gridName, values));
};

const FilterBuilderInner = compose(
	withProps(({ gridName }) => ({ form: `${gridName}_advancedSearch` })),
	reduxForm({
		onChange: debounce((values, dispatch, { gridName }) => {
			if(values && (values.statusMGMT || values.distDueMGMT || values.sentDueMGMT || values.statusReci || values.distDueReci || values.sentDueReci || values.distributionDate || values.reportType || values.snTitle || values.product || values.study)){
				return ''
			}
			const searchParam = (values && values.searchParam) || '';
			if(values && searchParam.length === 0) {
				if(values && (values.status || values.distDue || values.sentDue)) {
					dispatch(filterHomePageGrid(gridName, values))
				} else 
				dispatch(refreshManagement(gridName, formName => change(formName, 'searchParam', '')));
			} else if(values && searchParam.length === 1) {
					if(values && (values.status || values.distDue || values.sentDue)) {
						dispatch(filterHomePageGrid(gridName, values))
					} else {
						return ''
					}
				} else if(values && (searchParam.length >= 2)) {
					 dispatch(refreshSort(gridName, values))
				}
			 
		}, 500),
		onSubmit,
	})
)(FilterBuilderForm);

const FilterBuilder = ({ children }) => {
	const gridName = useGridContext();
	const initialValues = useSelector(state => getFilter(state, gridName) || {});
	return <FilterBuilderInner gridName={gridName} initialValues={initialValues}>{children}</FilterBuilderInner>;
};

export default FilterBuilder;
